import React from 'react';
import Text from "theme/Text";
import { ThemedBlockTitleStyles } from "styles/themed";
import isEqual from 'react-fast-compare'
import { parseThemedProps } from 'utils/helper-theme'

const ThemedBlockTitle = ({ style, ...props }) => {
	
	const themedProps = parseThemedProps( props )

	const styles = [
		ThemedBlockTitleStyles.text,
		themedProps.themedStyles,
		style
	];

	return (
		<Text
			category="s1"
			style={ styles }>
			
			{ props.children }
		</Text>
	);
}

export default React.memo( ThemedBlockTitle, isEqual );
